module.exports = __webpack_public_path__ + "static/media/pitt_coe.76930b17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/pitt_coe.jpg
// module id = 486
// module chunks = 0